module.exports = __webpack_public_path__ + "img/cup.7ce0376c.svg";